<template>
    <div class="recharge">
        <p class="font28" style="color: #333333">充值金额</p>
        <div class="recharge-money flex align-center">
            <span class="recharge-money-icon">¥</span>
            <van-field maxlength="5" v-model="money" disabled type="digit" clearable></van-field>
        </div>
        <van-row class="recharge-money-list" gutter="10">
            <van-col span="6" v-for="(item, index) in rechargeList" :key="index" @click="pickMoney(item,index)">
                <div :class="['recharge-money-item', active == index ? 'recharge-money-itemA' : 'recharge-money-itemD']">
                    {{ (Number(item.chargeMoney) - Number(item.giveMoney)).toFixed(0)}}元
                    <img v-if="item.giveMoney" src="@/assets/images/惠.png" alt="" />
                </div>
                <div v-if="item.remark" class="remark"> {{item.remark}}</div>
            </van-col>
        </van-row>

        <div class="recharge-confirm">
            <van-button :loading="loading" class="comfirm-btn" @click="recharge">立即充值</van-button>
        </div>
    </div>
</template>

<script>
import { submitParkingOrderFromApp, getMyMerchantRule } from "@/api/api";
import { throttleBytimestamp, obj2Param } from "@/libs/tools";
import { calcPayChannel } from '@/libs/env'
import { mapGetters } from 'vuex'

export default {
    name: "Recharge",
    data() {
        return {
            money: 20,
            showMoney: 0,
            active: 0,
            rechargeList: [
                {
                    chargeMoney: 20, //金额
                    giveMoney: 0, //优惠金额
                    id: 1,
                },
                {
                    chargeMoney: 50,
                    giveMoney: 0,
                    id: 2,
                },
                {
                    chargeMoney: 100,
                    giveMoney: 0,
                    id: 3,
                },
                {
                    chargeMoney: 200,
                    giveMoney: 0,
                    id: 4,
                },
                {
                    chargeMoney: 300,
                    giveMoney: 0,
                    id: 5,
                },
                {
                    chargeMoney: 500,
                    giveMoney: 0,
                    id: 6,
                },
                {
                    chargeMoney: 1000,
                    giveMoney: 0,
                    id: 7,
                },
                {
                    chargeMoney: 2000,
                    giveMoney: 0,
                    id: 8,
                },
            ],
            loading: false,
            isFullMinus: false, //是否满减
            couponMoney: 0,
            couponItem: {}, //优惠配置
        };
    },

    computed: {
        ...mapGetters({ appEnv: 'getAppEnv' })
    },
    mounted() {
        getMyMerchantRule().then((res) => {
            if (res.data.length > 0) {
                this.isFullMinus = true;
                this.rechargeList = res.data;
                this.money = this.rechargeList[0].chargeMoney - this.rechargeList[0].giveMoney
                this.couponMoney = this.rechargeList[0].giveMoney
            }
        });
    },
    watch: {
        money: {
            handler(newValue, oldValue) {
                // this.couponMoney = 0;
                // this.couponItem = {};
                // if (!this.isFullMinus) return;
                // let item = {
                //     chargeMoney: 0,
                // };
                // //根据优惠规则计算优惠金额
                // for (let i of this.rechargeList) {
                //     if (i.chargeMoney <= newValue && i.chargeMoney >= item.chargeMoney && i.giveMoney) {
                //         item = i;
                //     }
                // }
                // console.log(item);
                // this.couponMoney = item.giveMoney ? item.giveMoney : 0;
                // this.couponItem = item;
            },
        },
    },
    methods: {

        pickMoney(item, index) {
            this.money = Number(item.chargeMoney - item.giveMoney).toFixed(0)
            this.couponMoney = item.giveMoney
            this.active = index;

        },
        //充值
        recharge: throttleBytimestamp(function () {
            if (!this.money || this.money == 0) {
                this.$toast("充值金额必须大于0");
                return;
            }
            if (this.money > 10000) {
                this.$toast("充值金额最高为1万元");
                return;
            }

            let money = Number(this.money)
            money = (money > 0 ? money : 0).toFixed(2);
            let obj = {
                business: "paymentMerchant",
                parkType: 1,
                certId: localStorage.getItem("openId"),
                orderInfo: [
                    {
                        buyer: localStorage.getItem("userId"),
                        couponMoney: Number(this.couponMoney),
                        couponRandomMoney: 0,
                        couponTicketMoney: 0,
                        goodDetail: "代付余额充值",
                        goodSubject: "代付余额充值",
                        orderMoney: Number(this.money) + Number(this.couponMoney),
                        payForMoney: 0,
                        realMoney: this.money,
                        scanDiscount: 0,
                        scanDiscountConfigId: null,

                    },
                ],
                payChannel: calcPayChannel(this.appEnv, 2),
                totalRealMoney: money,
            };
            this.loading = true;

            submitParkingOrderFromApp(obj)
                .then((res) => {
                    if (this.appEnv.appEnv == 'miniprogram') {
                        this.miniprogramHandle(res)
                    } else {
                        window.location.href = res.data.payUrl
                    }

                })
                .finally(() => {
                    this.loading = false
                })
        }, 2000),

        miniprogramHandle(res) {
            let signParam = res.data.signParam;
            let obj = {
                realMoney: this.money,
                timeStamp: signParam.timeStamp,
                nonceStr: signParam.nonceStr,
                package: encodeURIComponent(signParam.package),
                sign: encodeURIComponent(signParam.sign),
                signType: signParam.signType,
            };
            let str = obj2Param(obj);
            wx.miniProgram.navigateTo({
                url: `/pages/tab2/pay/pay?${str}`,
            });
        },

    },
};
</script>

<style lang="less" scoped>
@import "~@/assets/style/color.less";
.quickPay-tip {
    margin-top: 70px;

    img {
        width: 24px;
        height: 24px;
    }

    p {
        font-size: 26px;
        color: #616161;
        margin-left: 8px;
    }
}
.remark {
    text-align: center;
    color: #616161;
    margin-top: -20px;
}
.recharge {
    min-height: 100vh;
    background: #fff;
    padding: 24px;

    .recharge-money {
        // padding: 12px 0;
        margin-top: 24px;
        border-bottom: 1px solid #dbdada;

        .recharge-money-icon {
            font-size: 104px;
        }
    }

    .recharge-money-list {
        margin-top: 44px;

        .recharge-money-item {
            width: 165.5px;
            height: 73px;
            text-align: center;
            line-height: 73px;
            margin-bottom: 27px;
            color: #616161;
            font-size: 34px;
            border-radius: 5px;
            position: relative;
        }
        img {
            width: 35px;
            height: 29px;
            position: absolute;
            // top: -20px;
            right: -10px;
            // margin-top: -100px;
            // margin-left: -100px;
        }

        .recharge-money-itemA {
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            color: #fff;
        }

        .recharge-money-itemD {
            border: 1px solid #bfbfbf;
            color: #616161;
        }
    }
    .comfirm-btn {
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }
    .recharge-confirm {
        margin-top: 60px;
    }
}
</style>
<style lang="less" scoped>
/deep/ .van-field__control:disabled {
    color: #323233;
    font-size: 32px;
    -webkit-text-fill-color: #323233;
}
.recharge-money {
    .van-field__control {
        caret-color: #009af3;
        font-size: 32px;
    }
}
</style>
